import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  CollectBotBgLogo,
  NeokredNewLogo,
} from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { validateEmail } from "../../../../utility/emailValidator";
import ResizeListner from "../../../../utility/ResizeListner";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import CustomPasswordInput from "../../../components/ui_comps/CustomPasswordInput";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";

function CreatePasswordIndex({ onClick, onSuccess }) {
  const { height, width } = ResizeListner();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [verified, setVerified] = useState("");
  const [tokenValues, setTokenValues] = useState("");
  const [userID, setUserID] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    const currentURL = window.location.href;
    const parts = currentURL.split("?");
    const part1 = parts[0];
    const part2 = parts[1];
    let tokenValue = part2.slice(6);
    setTokenValues(tokenValue);
  }, []);

  useEffect(() => {
    if (tokenValues) {
      ApiRequestGet.verifyToken({
        token: tokenValues,
      })
        .then((response) => {
          if (response.statusCode === STATUS_CODE_200) {
            setUserID(response.data);
            enqueueSnackbar(response.message, {
              variant: "success",
            });
          } else {
            enqueueSnackbar(response.message, {
              variant: "error",
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          enqueueSnackbar(err.message, {
            variant: "error",
          });
          setLoading(false);
        });
    }
  }, [tokenValues]);

  const onClickConfirmPassword = () => {
    setLoading(true);
    ApiRequestPost.setPassword({
      userID: userID,
      password: password,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/login");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    let url = window.location.href;
    if (url.includes("https://payinpayout.in")) {
      setVerified(NeokredNewLogo);
    } else {
      setVerified(CollectBotBgLogo);
    }
  }, []);

  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={verified}
          alt="logo"
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div>
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              marginBottom: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            New Password
          </p>
          <p style={{ color: "#2D3748", margin: "10px 0" }}>
            Enter the new password amd confirm it to change your password.
          </p>

          <div style={{ marginTop: "25px" }}>
            <CustomPasswordInput
              value={password}
              onChange={setPassword}
              placeholder="New Password"
              isError={() => {}}
              autoComplete="off"
            />
          </div>

          <div style={{ marginTop: "25px" }}>
            <CustomPasswordInput
              value={confirmPassword}
              onChange={setConfirmPassword}
              placeholder="Confirm New Password"
              isError={() => {}}
              autoComplete="off"
            />
          </div>

          <p style={{ color: "#2D3748", margin: "10px 0" }}>
            password must be minimum 12 charaters, one lowercase charater, one
            uppercase charater, one number and one special charater
          </p>

          <CustomButton
            loading={loading}
            title="Continue"
            styles={{
              width: "100%",
              marginTop: 40,
              height: "50px",
              borderRadius: "4px",
            }}
            textStyle={{
              color: colorWhite,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              let pattern =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,16})/;
              if (!pattern.test(password)) {
                enqueueSnackbar(
                  "password must be minimum 12 charaters, one lowercase charater, one uppercase charater, one number and one special charater(@$!%*&)",
                  {
                    variant: "error",
                  }
                );
                return;
              }

              if (password !== confirmPassword) {
                enqueueSnackbar(
                  "password and confirm password should be same",
                  {
                    variant: "error",
                  }
                );
                return;
              }
              onClickConfirmPassword();
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CreatePasswordIndex;
